<style lang="stylus">
    .WarnTips-tips
        width fit-content
        padding 8px 16px
        background rgba(0, 0, 0, 0.04)
        border-radius 6px

        p
            font-size 14px
            line-height 16px
            max-width 100%
            overflow hidden
            text-overflow ellipsis

        span
            font-size 14px
            line-height 16px
            user-select none

        .WarnTips-title
            color #222222

        .WarnTips-link
            color #FF7100
            cursor pointer

            &:hover
                text-decoration underline

    .dark-theme__WarnTips-tips
        background rgba(255, 255, 255, 0.08)

        .WarnTips-title
            color #fff
</style>

<template>
    <div class="WarnTips-tips" :class="{ 'dark-theme__WarnTips-tips': isPCDarkMode == 2 }" v-if="show">
        <p :title="titleText">
            <span class="WarnTips-title">{{ normalText }}</span>
            <slot name="invite"></slot>
            <span class="WarnTips-link" v-if="showVipText" @click="toBuy">{{ vipText }}</span>
        </p>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class WarnTips extends Vue {
        @Prop()
        show;
        @Prop({ default: true })
        showVipText;
        @Prop()
        normalText;
        @Prop()
        vipText;
        @Prop()
        triggerStr;

        get titleText() {
            const normalText = this.normalText ? this.normalText : "";
            const vipText = this.showVipText ? this.vipText : "";
            return (normalText + vipText).replace(/\<.[^\>]*\>/g, "");
        }
        toBuy() {
            this.$emit("clickBuy");
            this.$openBuyPage(this.triggerStr);
        }
        created() {}
        mounted() {}
    }
</script>
